export function flexible () {
  const docEl = document.documentElement

  // set 1rem = viewWidth / 10
  function setRemUnit () {
    const width = docEl.clientWidth > 640 ? 640 : docEl.clientWidth
    const rem = width / 10
    docEl.style.fontSize = rem + 'px'
  }
  setRemUnit()
  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
}

export function mediaDevice () {
  let mediaSize = document.body.clientWidth
  if (mediaSize >= 1024) {
    return 'pc'
  } else if (mediaSize >= 768 && mediaSize < 1024) {
    return 'ipad'
  } else {
    return 'mobile'
  }
}

export function getPlantform (userAgent = navigator.userAgent) {
  if (/Android|iPhone|iPad|iPod|Windows Phone|BlackBerry/i.test(userAgent)) {
    return 'mobile'
  } else {
    return 'pc'
  }
}
export function isIos () {
  if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}
export function isAndroid () {
  if (/Android/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}
export function isWechat () {
  return /microMessenger/i.test(navigator.userAgent)
}

export function shouldSetTitle () {
  return /microMessenger|QQ/i.test(navigator.userAgent)
}

export function isQQBrowser () {
  return /MQQBrowser/i.test(navigator.userAgent)
}

export function isPC () {
  return getPlantform() == 'pc'
}

export function isMobile () {
  return getPlantform() == 'mobile'
}

export function setTitle (title) {
  if (shouldSetTitle()) {
    document.title = title
    let i = document.createElement('iframe')
    i.src = '//www.bootcdn.cn/assets/ico/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  } else {
    document.title = title
  }
}

export function loadScript (src, variable) {
  if (variable && window[variable]) {
    return Promise.resolve()
  }
  return new Promise(resolve => {
    const ele = document.createElement('script')
    ele.src = src
    document.getElementsByTagName('head')[0].appendChild(ele)
    // 兼容ie10
    ele.onload = ele.onreadystatechange = function () {
      if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
        resolve()
      }
    }
  })
}

export function loadStyle (src) {
  return new Promise(resolve => {
    const ele = document.createElement('link')
    ele.href = src
    ele.type = 'text/css'
    ele.rel = 'stylesheet'
    document.getElementsByTagName('head')[0].appendChild(ele)
    ele.onload = function () {
      resolve()
    }
  })
}

export function hasVariable (variable) {
  return new Promise(resolve => {
    if (!hasVariableHandle(variable, resolve)) {
      hasVariableTimer(variable, resolve)
    }
  })
}

function hasVariableHandle (variable, resolve) {
  if (window[variable]) {
    resolve()
    return true
  }
}

function hasVariableTimer (variable, resolve) {
  setTimeout(() => {
    if (hasVariableHandle(variable, resolve)) return
    hasVariableTimer(variable, resolve)
  }, 10)
}
